import { render, staticRenderFns } from "./LoginUpgradeDialog.vue?vue&type=template&id=246de81d&"
import script from "./LoginUpgradeDialog.vue?vue&type=script&lang=ts&"
export * from "./LoginUpgradeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LoginUpgradeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports